import React, { useState, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchOpen, setSearchOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    const q = searchQuery.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setSearchQuery('');
    setSearchOpen(false);
    setMenuOpen(false);
  };

  // Detect current language — Hindi is the default
  const isHindi = () => localStorage.getItem('preferredLang') !== 'en';
  const [hindi] = useState(isHindi);

  const toggleLang = useCallback(() => {
    if (hindi) {
      // Switch to English
      localStorage.setItem('preferredLang', 'en');
      document.cookie = 'googtrans=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
      document.cookie = 'googtrans=; path=/; domain=' + window.location.hostname + '; expires=Thu, 01 Jan 1970 00:00:00 UTC';
    } else {
      // Switch back to Hindi (default)
      localStorage.removeItem('preferredLang');
      document.cookie = 'googtrans=/en/hi; path=/';
      document.cookie = 'googtrans=/en/hi; path=/; domain=' + window.location.hostname;
    }
    window.location.reload();
  }, [hindi]);

  const navLinks = [
    { label: 'Home', to: '/' },
    { label: 'Central Govt', to: '/category/central-govt' },
    { label: 'State Govt', to: '/category/state-govt' },
    { label: 'Bank Jobs', to: '/category/bank-jobs' },
    { label: 'Contact Us', to: '/contact' },
  ];

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <span className="logo-career">Rajasthan</span>
          <span className="logo-portal">Jobs</span>
        </Link>

        <div className="navbar-actions">
          <button className="search-toggle" onClick={() => setSearchOpen(!searchOpen)} aria-label="Toggle search">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          </button>
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <span /><span /><span />
          </button>
        </div>

        <ul className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {navLinks.map(link => (
            <li key={link.label}>
              <Link
                to={link.to}
                className={`nav-link ${location.pathname === link.to ? 'active' : ''}`}
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <button className="lang-toggle" onClick={toggleLang} title={hindi ? 'Switch to English' : 'हिंदी में देखें'}>
              {hindi ? 'EN' : 'हि'}
            </button>
          </li>
        </ul>
      </div>
      {searchOpen && (
        <div className="navbar-search-bar">
          <form onSubmit={handleSearch} className="search-form">
            <input
              type="text"
              className="search-input"
              placeholder="Search jobs... e.g. Railway, Bank, SSC"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              autoFocus
            />
            <button type="submit" className="search-btn">Search</button>
          </form>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
